/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhzentrale11Inputs */

const en__field_enum_ikhzentrale11 = /** @type {(inputs: _Field_Enum_Ikhzentrale11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zentrale Einrichtungen GU`)
};

const de__field_enum_ikhzentrale11 = /** @type {(inputs: _Field_Enum_Ikhzentrale11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zentrale Einrichtungen GU`)
};

/**
* | output |
* | --- |
* | "Zentrale Einrichtungen GU" |
*
* @param {_Field_Enum_Ikhzentrale11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhzentrale11 = /** @type {((inputs?: _Field_Enum_Ikhzentrale11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhzentrale11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhzentrale11(inputs)
	return de__field_enum_ikhzentrale11(inputs)
});
export { _field_enum_ikhzentrale11 as "_field_enum_IKHZENTRALE" }